import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { NumberSuffixPipe } from './number-suffix/number-suffix.pipe';
import { SafePipe } from './safe/safe.pipe';
import { OrdinalNumberPipe } from './ordinal-number/ordinal-number.pipe';
import { ConsoleLogPipe } from './console-log/console-log.pipe';
import { AbbreviateNumberPipe } from './abbreviate-number/abbreviate-number.pipe';
import { IconNamePipe } from './icon-name/icon-name.pipe';
import { OrderByPipe } from './order-by/order-by.pipe';
import { MarkdownPipe } from './markdown/markdown.pipe';
import { MarkdownPreviewPipe } from './markdown-preview/markdown-preview.pipe';
import { LocalTimePipe } from './local-time/local-time.pipe';
import { PremiumStatusPipe } from './check-premium-status/premium-status.pipe';
import { FindPremiumPartnerPipe } from '@cpd-app/shared-module/pipes/check-premium-status/find-premium-partner.pipe';
import { MatchQualityPipe } from './match-quality/match-quality.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    NumberSuffixPipe,
    OrdinalNumberPipe,
    SafePipe,
    ConsoleLogPipe,
    AbbreviateNumberPipe,
    IconNamePipe,
    OrderByPipe,
    MarkdownPipe,
    MarkdownPreviewPipe,
    LocalTimePipe,
    PremiumStatusPipe,
    FindPremiumPartnerPipe,
    MatchQualityPipe
  ],
  exports: [
    NumberSuffixPipe,
    OrdinalNumberPipe,
    SafePipe,
    ConsoleLogPipe,
    AbbreviateNumberPipe,
    IconNamePipe,
    OrderByPipe,
    MarkdownPipe,
    MarkdownPreviewPipe,
    LocalTimePipe,
    PremiumStatusPipe,
    FindPremiumPartnerPipe,
    MatchQualityPipe
  ],
  providers: [CurrencyPipe]
})
export class PipesModule {}
